/**
 * Localization messages for Footer component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Buttons
  'Save & Activate Rule': 'ruleRecs.footer.saveAndActivateRule',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type FooterMessage = keyof typeof invertedMessages;

export default invertedMessages;
